/**
 * Catálogo de textos en español (europeo) para la funcionalidad Libros & Reglas / campaña
 * (`@gamecodex/world-ui` → `features/books`).
 *
 * Las claves reflejan las llamadas `t('books.*')` en los componentes React de la funcionalidad. Los valores
 * son las cadenas exactas en español extraídas durante el barrido de i18n.
 */
export const booksEs = {
  // BackerDownloadModal.tsx
  'books.backerModal.title': 'Reclama tu PDF de Mecenas',
  'books.backerModal.sendLinkError': 'No pudimos enviar tu enlace de acceso en este momento. Inténtalo de nuevo en breve.',
  'books.backerModal.checkInboxPrefix': 'Revisa tu bandeja de entrada en',
  'books.backerModal.checkInboxSuffix':
    'Si respaldaste con ese correo, un enlace de acceso está en camino — haz clic para reclamar tu copia.',
  'books.backerModal.linkAutoSignIn': 'El enlace se abre en este sitio y te inicia sesión automáticamente. No necesitas contraseña.',
  'books.backerModal.signInIntro':
    'Introduce el correo con el que respaldaste. Te enviaremos un enlace de acceso de un clic y prepararemos tu copia personal.',
  'books.backerModal.pledgeEmailLabel': 'Correo de la cuenta de respaldo',
  'books.backerModal.emailLinkCta': 'Envíame un enlace de acceso por correo',
  'books.backerModal.prepareTimeout':
    'Tu copia tarda más de lo esperado en prepararse. Por favor, inténtalo de nuevo en unos minutos.',
  'books.backerModal.notEntitled': 'Has iniciado sesión, pero tu respaldo no incluye este libro.',
  'books.backerModal.notClaimable': 'Este libro no se ofrece como descarga de mecenas.',
  'books.backerModal.prepareError': 'No pudimos preparar tu descarga en este momento. Inténtalo de nuevo en breve.',
  'books.backerModal.signedInAs': 'Sesión iniciada como',
  'books.backerModal.signOut': 'Cerrar sesión',
  'books.backerModal.verified': 'Verificado',
  'books.backerModal.welcomeBack': ' — bienvenido de vuelta,',
  'books.backerModal.backerNumber': '(Mecenas #{number})',
  'books.backerModal.copyReady':
    'Tu copia personal está lista. Este enlace es personal y expirará en breve — por favor, no lo compartas.',
  'books.backerModal.downloadPdf': 'Descarga tu PDF',
  'books.backerModal.dtrpgEmailLabel': 'Correo de la cuenta DriveThruRPG',
  'books.backerModal.optional': '(opcional)',
  'books.backerModal.dtrpgWarn':
    'Añade esto para reflejar también la compra en tu biblioteca de DriveThruRPG. Omítelo y tu copia seguirá siendo descargable aquí.',
  'books.backerModal.preparingCopy': 'Preparando tu copia…',
  'books.backerModal.prepareDownload': 'Preparar y Descargar',

  // BackerVerifyPage.tsx
  'books.backerVerify.missingToken': 'Este enlace de acceso no tiene su token. Solicita un nuevo enlace desde la página del libro.',
  'books.backerVerify.invalidToken':
    'Este enlace de acceso no es válido o ha caducado. Solicita uno nuevo desde la página del libro.',
  'books.backerVerify.seoTitle': 'Acceso de mecenas',
  'books.backerVerify.seoDescription': 'Verificando tu enlace de acceso de mecenas de Grymwyrd.',
  'books.backerVerify.confirming': 'Confirmando tu acceso de mecenas…',
  'books.backerVerify.signedInHeading': 'Has iniciado sesión',
  'books.backerVerify.signedInAs': 'Sesión iniciada como',
  'books.backerVerify.headBackPrefix': 'Vuelve al libro y haz clic en',
  'books.backerVerify.downloadWord': 'Descargar',
  'books.backerVerify.headBackSuffix': 'para reclamar tu copia.',
  'books.backerVerify.backToBook': 'Volver a tu libro',
  'books.backerVerify.browseAthenaeum': 'Explora la Ateneo',
  'books.backerVerify.problemHeading': 'Problema con el enlace de acceso',

  // BookCard.tsx
  'books.card.viewAria': 'Ver {title}',
  'books.card.coverAlt': 'Portada de {title}',
  'books.card.owned': 'Poseo',

  // BookCover.tsx
  'books.cover.coverAlt': 'Portada de {title}',

  // BookStorePage.tsx
  'books.store.seoTitle': 'Libros y Reglas',
  'books.store.seoDescription':
    'Tomos del crepúsculo eterno — manuales de reglas principales, el SRD ilustrado y aventuras boscureñas. Compra para desbloquear módulos y ganar monedas.',
  'books.store.eyebrow': 'La Ateneo',
  'books.store.heading': 'Libros y Reglas',
  'books.store.intro':
    'Adquiere los tomos que vinculan el mundo. Cada compra desbloquea módulos jugables en tus campañas y te recompensa con monedas para la economía del mundo.',
  'books.store.filterAria': 'Filtrar libros por tipo',
  'books.store.filterAll': 'Todo',
  'books.store.loading': 'Desbloqueando el archivo…',
  'books.store.empty': 'Ningún tomo coincide con esta categoría aún. Los escribas aún siguen trabajando.',

  // BuyButton.tsx
  'books.buy.checkoutUnavailable': 'El pago no está disponible aún. Por favor, inténtalo de nuevo pronto.',
  'books.buy.signInToClaim': 'Inicia sesión para reclamar este tomo.',
  'books.buy.ledgerSealed': 'El libro mayor del mercader está sellado por ahora — el pago llegará pronto.',
  'books.buy.inLibrary': 'En Tu Biblioteca',
  'books.buy.openingVault': 'Abriendo la bóveda…',
  'books.buy.claimFree': 'Reclamar Gratis',
  'books.buy.buyPrice': 'Comprar — {price}',
  'books.buy.unlockPrefix': 'Comprar → desbloquear módulos +',
  'books.buy.coinsSuffix': '{coins} monedas',

  // BookDetailPage.tsx
  'books.detail.loading': 'Pasando las páginas…',
  'books.detail.backToAthenaeum': 'Volver a la Ateneo',
  'books.detail.unlockOwned': 'Posees este tomo — su tradición de Grymwyrd se desbloquea en toda la enciclopedia.',
  'books.detail.unlockClaim': 'Reclama este tomo para desbloquear su tradición de Grymwyrd en toda la enciclopedia.',
  'books.detail.returnTo': 'Volver a {label}',
  'books.detail.backerCta': '¿Mecenas? Descarga tu PDF',
  'books.detail.coinsEarned': 'Ganaste {coins} monedas con esta compra.',
  'books.detail.coinsGranted': 'La compra otorga {coins} monedas a tu tesoro.',
  'books.detail.byAuthor': 'Por {author}',
  'books.detail.statPrice': 'Precio',
  'books.detail.statPages': 'Páginas (última compilación)',
  'books.detail.statWords': 'Palabras (última compilación)',
  'books.detail.ofThisTome': 'De Este Tomo',
  'books.detail.noDescription': 'No se ha inscrito descripción para este volumen aún.',
  'books.detail.previewHeading': 'Vista Previa',
  'books.detail.previewBlurb': 'Echa un vistazo a una muestra de este tomo antes de reclamarlo.',
  'books.detail.readPreview': 'Leer una vista previa',
  'books.detail.tocHeading': 'Tabla de Contenidos',
  'books.detail.tocEmpty': 'El contenido de este tomo no ha sido catalogado aún.',
  'books.detail.pageAbbrev': 'p. {page}',
  'books.detail.unlockedHeading': 'Entradas de Enciclopedia Desbloqueadas',
  'books.detail.unlockedOwnedNote': 'Ahora parte de tu enciclopedia viviente:',
  'books.detail.unlockedLockedNote':
    'Compra este tomo para inscribir sus criaturas, hechizos y secretos en tu enciclopedia — y reclamar',
  'books.detail.coinsAmount': '{coins} monedas',
  'books.detail.attributionsHeading': 'Atribuciones y Licencias',
  'books.detail.attributionSource': 'Fuente',
  'books.detail.attributionLink': 'enlace',

  // CampaignLandingPage.tsx
  'books.campaign.liveCampaign': 'Campaña en Directo',
  'books.campaign.backThisProject': 'Respalda Este Proyecto',
  'books.campaign.viewStretchGoals': 'Ver Objetivos de Extensión',
  'books.campaign.pledged': 'Respaldado',
  'books.campaign.backers': 'Mecenas',
  'books.campaign.pitchHeading': 'El Propósito',
  'books.campaign.backerUnlockedHeading': 'Entradas Desbloqueadas por Mecenas',
  'books.campaign.backerUnlockedBlurb':
    'Los mecenas obtienen acceso temprano a contenido que fluye directamente a la enciclopedia viviente. Aquí hay una muestra de lo que ya es canon:',
  'books.campaign.previewsEmpty': 'Se está inscribiendo nuevo canon — regresa cuando se desbloqueen objetivos.',
  'books.campaign.choosePledge': 'Elige Tu Respaldo',
  'books.campaign.mostBacked': 'Más Respaldado',
  'books.campaign.pledgeAmount': 'Respaldar {amount}',
  'books.campaign.pledgeFooter':
    'Los respaldos se procesan de forma segura en el pago. Las recompensas de respaldo (monedas, módulos y desbloqueos de enciclopedia) se otorgan a tu cuenta de Grymwyrd una vez que el servicio de campaña esté en línea.',

  // LanguageSelect.tsx
  'books.language.label': 'Idioma',

  // PreviewModal.tsx
  'books.preview.title': 'Vista Previa — {title}',
  'books.preview.pdfAria': 'Vista previa del PDF de {title}',
  'books.preview.cannotDisplay': 'Tu conjurador no puede mostrar la vista previa en línea.',
  'books.preview.openNewTab': 'Abre la vista previa en una nueva pestaña',
  'books.preview.preparingHeading': 'La vista previa se está preparando.',
  'books.preview.preparingBody':
    'Una muestra de este tomo está siendo inscrita por la escribanía y aparecerá aquí en breve. Mientras tanto, vislumbra lo que hay dentro:',
  'books.preview.excerptLabel': 'Extracto — {title}',
  'books.preview.excerptFallback':
    'Más allá de este umbral yacen páginas impregnadas de pavor y maravilla. Adquiere el tomo para seguir leyendo.',
  'books.preview.noExcerpt': 'No se ha catalogado extracto para este volumen aún.',

  // RulesPage.tsx
  'books.rules.sectionSpells': 'Hechizos',
  'books.rules.sectionMonsters': 'Monstruos',
  'books.rules.sectionMagicItems': 'Objetos Mágicos',
  'books.rules.sectionWeapons': 'Armas',
  'books.rules.sectionArmor': 'Armaduras',
  'books.rules.sectionSkills': 'Habilidades',
  'books.rules.entriesCount': '{entries} entradas',
  'books.rules.readingLabel': 'Leyendo {label}…',
  'books.rules.noneCatalogued': 'No hay {label} catalogados en este sistema aún.',
  'books.rules.browseAll': 'Explora todo {label} en la enciclopedia →',
  'books.rules.seoTitle': 'Reglas y SRD',
  'books.rules.seoDescription':
    'Explora el Documento de Referencia del Sistema — hechizos, monstruos, objetos y las reglas que vinculan el crepúsculo eterno. SRD 5e ahora, con más sistemas próximamente.',
  'books.rules.eyebrow': 'El Códice',
  'books.rules.heading': 'Reglas y Documento de Referencia del Sistema',
  'books.rules.intro':
    'El contenido de juego abierto que impulsa Grymwyrd. Explora entradas relevantes a las reglas e inmérjete en la enciclopedia completa para bloques de estadísticas y tradición. Grymwyrd viene con el SRD 5e actualmente — PF2e y otros sistemas están llegando.',
  'books.rules.loading': 'Consultando el códice…',
  'books.rules.gameSystems': 'Sistemas de Juego',
  'books.rules.noSystems': 'Ningún sistema de juego está registrado aún.',
  'books.rules.openSrd': 'Abrir SRD',
  'books.rules.lockedComingSoon': 'Bloqueado — próximamente',
  'books.rules.referenceContent': '{name} — Contenido de Referencia',
  'books.rules.releasedUnder': 'Lanzado bajo {license}',
  'books.rules.licenseLink': 'licencia',

  // StretchGoals.tsx
  'books.stretch.goalProgressAria': 'Progreso de financiación de {title}',
  'books.stretch.unlockedAdded': 'Desbloqueado — añadido a la enciclopedia',
  'books.stretch.percentFunded': '{pct}% financiado',
  'books.stretch.autoPopulates': 'Puebla automáticamente la enciclopedia',
  'books.stretch.raisedSoFar': 'Recaudado hasta ahora',
  'books.stretch.backers': 'Mecenas',
  'books.stretch.overallAria': 'Financiación general de la campaña',
  'books.stretch.heading': 'Objetivos de Extensión',
} as const
